import { Entity } from '@backstage/catalog-model';

/**
 * Check if an entity is an Auth0 application (Resource with type auth0-application)
 */
export const isAuth0Application = (entity: Entity): boolean => {
  return (
    entity.kind === 'Resource' && entity.spec?.type === 'auth0-application'
  );
};
